import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import MessageStandard from 'components/partials/MessageStandard'
import MessageError from 'components/partials/MessageError'

function Message({ message, standard, error }) {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(true)

  const handleDismiss = () => {
    setIsVisible(false)
  }

  if (!isVisible) {
    return null
  }

  return (
    <>
      {standard && (
        <MessageStandard
          message={message}
          closeLabel={t('close')}
          onDismiss={handleDismiss}
        />
      )}
      {error && (
        <MessageError message={message} />
      )}
    </>
  )
}

export default Message
